import {PublicJobCard} from "./PublicJobCard";
import {useGetFeaturedJobsQuery} from "../../store/services/publicApi";
import {MappedJob} from "../../store/services/jobApi";
import {SectionHeader} from "./Shared";

export const LatestJobOpportunities = () => {
    const {data: Jobs = [], isLoading} = useGetFeaturedJobsQuery(undefined);

    if (isLoading || !Jobs.length) {
        return null;
    }

    return (
        <section className="oec-section" id="jobs">
            <div className="oec-section-inner">
                <SectionHeader
                    title="Featured Jobs"
                    linkLabel="View All Jobs"
                    linkTo="/jobs"
                />

                <div className="oec-card-grid oec-card-grid-4">
                    {Jobs.slice(0, 4).map((job: MappedJob) => (
                        <PublicJobCard key={job.id} job={job}/>
                    ))}
                </div>
            </div>
        </section>
    );
};
